// {
// 	"data": {
// 		"skyscraperAdData": [
// 			{
// 				"adUnitPath": "/22150725263/300x250-MyDNB-portal-desktop-2",
// 				"adSize": "[300, 250]",
// 				"adDivId": "div-gpt-ad-1656103532904-0"
// 			},
// 			{
// 				"adUnitPath": "/22150725263/300x250-MyDNB-portal-desktop-2",
// 				"adSize": "[300, 250]",
// 				"adDivId": "div-gpt-ad-1656103532904-0"
// 			}
// 		]
// 	},
// 	"identifier": "zaab28ca70ef6426aa273030dd9dfd84b"
// }

export const companyProfileGoogleAdsData = {
  data: {
    skyscraperAdData: [
      {
        adUnitPath: "/22150725263/160x600-BusinessProfileDeskLeft",
        adSize: "[160, 600]",
        adDivId: "div-gpt-ad-1647878190038-0",
      },
      {
        adUnitPath: "/22150725263/160x600-BusinessProfileDeskLeft",
        adSize: "[160, 600]",
        adDivId: "div-gpt-ad-1647878190038-1",
      },
    ],
  },
};

export const contactProfileGoogleAdsData = {
  data: {
    skyscraperAdData: [
        {
          adUnitPath: "/22150725263/160x600-ContactProfileDeskRight",
          adSize: "[160, 600]",
          adDivId: "div-gpt-ad-1647878154384-0"
        },
        {
          adUnitPath: "/22150725263/160x600-ContactProfileDeskLeft",
          adSize: "[160, 600]",
          adDivId: "div-gpt-ad-1647877860713-0"
        }
    ]
}
}

export const contactDirectoryDesktopOne = {
  "spacingBottom": "40",
  "ad": [
      "{\"adUnitPath\":\"/22150725263/728x90-ConDir-desktop-1\",\"adWidth\":\"728\",\"adHeight\":\"90\",\"adDivId\":\"div-gpt-ad-1656358151069-0\"}",
      "{\"adUnitPath\":\"/22150725263/300x100-ConDir-mobile-1\",\"adWidth\":\"300\",\"adHeight\":\"100\",\"adDivId\":\"div-gpt-ad-1656358067910-0\"}"
  ],
  "spacingTop": "40",
  "lazyLoadAd": "true",
}

export const contactDirectoryLeftinThree = {
    "spacingBottom": "40",
    "ad": "{\"adUnitPath\":\"/22150725263/300x250-ConDir-Desktop-Left\",\"adWidth\":\"300\",\"adHeight\":\"250\",\"adDivId\":\"div-gpt-ad-1674606626763-0\"}",
    "spacingTop": "40",
    "lazyLoadAd": "true"
}

export const contactDirectoryMidinThree = {
    "spacingBottom": "40",
    "ad": "{\"adUnitPath\":\"/22150725263/300x250-ConDir-Desktop-Center\",\"adWidth\":\"300\",\"adHeight\":\"250\",\"adDivId\":\"div-gpt-ad-1674606656076-0\"}",
    "spacingTop": "40",
    "lazyLoadAd": "true"
}

export const contactDirectoryRightinThree = {
    "spacingBottom": "40",
    "ad": "{\"adUnitPath\":\"/22150725263/300x250-ConDir-Desktop-Right\",\"adWidth\":\"300\",\"adHeight\":\"250\",\"adDivId\":\"div-gpt-ad-1674606684531-0\"}",
    "spacingTop": "40",
    "lazyLoadAd": "true"
}

export const contactDirectoryDesktopTwo = {
  "spacingBottom": "40",
  "ad": [
      "{\"adUnitPath\":\"/22150725263/728x90-ConDir-desktop-2\",\"adWidth\":\"728\",\"adHeight\":\"90\",\"adDivId\":\"div-gpt-ad-1656358172025-0\"}",
      "{\"adUnitPath\":\"/22150725263/300x100-ConDir-mobile-2\",\"adWidth\":\"300\",\"adHeight\":\"100\",\"adDivId\":\"div-gpt-ad-1656358094653-0\"}"
  ],
  "spacingTop": "40",
  "lazyLoadAd": "true"
}

export const contactDirectoryDesktopThree = {
  "spacingBottom": "40",
  "ad": [
      "{\"adUnitPath\":\"/22150725263/728x90-ConDir-desktop-3\",\"adWidth\":\"728\",\"adHeight\":\"90\",\"adDivId\":\"div-gpt-ad-1656358196413-0\"}",
      "{\"adUnitPath\":\"/22150725263/300x100-ConDir-mobile-3\",\"adWidth\":\"300\",\"adHeight\":\"100\",\"adDivId\":\"div-gpt-ad-1656358115502-0\"}"
  ],
  "spacingTop": "40",
  "lazyLoadAd": "true"
}

export const companyProfileLeftInThree = {
  "ad": "{\"adUnitPath\":\"/22150725263/300x250-BusDir-Desktop-Left\",\"adWidth\":\"300\",\"adHeight\":\"250\",\"adDivId\":\"div-gpt-ad-1674606181142-0\"}",
  "lazyLoadAd": "true",
}

export const companyProfileMidInThree = {
  "ad": "{\"adUnitPath\":\"/22150725263/300x250-BusDir-Desktop-Center\",\"adWidth\":\"300\",\"adHeight\":\"250\",\"adDivId\":\"div-gpt-ad-1674606258272-0\"}",
  "lazyLoadAd": "true",
}

export const companyProfileRightInThree = {
  "ad": "{\"adUnitPath\":\"/22150725263/300x250-BusDir-Desktop-Right\",\"adWidth\":\"300\",\"adHeight\":\"250\",\"adDivId\":\"div-gpt-ad-1674606311639-0\"}",
  "lazyLoadAd": "true",
}

export const companyProfileDesktopOne = {
 "spacingBottom": "40",
 "ad": [
      "{\"adUnitPath\":\"/22150725263/728x90-BusDir-desktop-1\",\"adWidth\":\"728\",\"adHeight\":\"90\",\"adDivId\":\"div-gpt-ad-1656357035738-0\"}",
      "{\"adUnitPath\":\"/22150725263/300x100-BusDir-mobile-1\",\"adWidth\":\"300\",\"adHeight\":\"100\",\"adDivId\":\"div-gpt-ad-1656357189921-0\"}"
  ],
  "spacingTop": "56",
  "lazyLoadAd": "true",
  "sling:resourceType": "dnb/dnb-mod/components/GenericAdComponent"
}

export const companyProfileDesktopTwo = {
"spacingBottom": "56",
"ad": [
      "{\"adUnitPath\":\"/22150725263/728x90-BusDir-desktop-2\",\"adWidth\":\"728\",\"adHeight\":\"90\",\"adDivId\":\"div-gpt-ad-1656357060795-0\"}",
      "{\"adUnitPath\":\"/22150725263/300x100-BusDir-mobile-2\",\"adWidth\":\"300\",\"adHeight\":\"100\",\"adDivId\":\"div-gpt-ad-1656357212488-0\"}"
  ],
  "spacingTop": "40",
  "lazyLoadAd": "true",
}

export const companyProfileDesktopThree = {
  "ad": [
      "{\"adUnitPath\":\"/22150725263/728x90-BusDir-desktop-3\",\"adWidth\":\"728\",\"adHeight\":\"90\",\"adDivId\":\"div-gpt-ad-1656357085683-0\"}",
      "{\"adUnitPath\":\"/22150725263/300x100-BusDir-mobile-3\",\"adWidth\":\"300\",\"adHeight\":\"100\",\"adDivId\":\"div-gpt-ad-1656357233656-0\"}"
  ],
  "spacingTop": "56",
  "lazyLoadAd": "true",
  "sling:resourceType": "dnb/dnb-mod/components/GenericAdComponent"
}

export const companyProfileDesktopFour = {
"spacingBottom": "40",
  "ad": [
      "{\"adUnitPath\":\"/22150725263/728x90-BusDir-desktop-4\",\"adWidth\":\"728\",\"adHeight\":\"90\",\"adDivId\":\"div-gpt-ad-1656357111898-0\"}",
      "{\"adUnitPath\":\"/22150725263/300x100-BusDir-mobile-4\",\"adWidth\":\"300\",\"adHeight\":\"100\",\"adDivId\":\"div-gpt-ad-1656357255896-0\"}"
  ],
  "spacingTop": "40",
  "lazyLoadAd": "true",
}

export const companyProfileDesktopFive = {
  "ad": [
      "{\"adUnitPath\":\"/22150725263/728x90-BusDir-desktop-5\",\"adWidth\":\"728\",\"adHeight\":\"90\",\"adDivId\":\"div-gpt-ad-1656357136274-0\"}",
      "{\"adUnitPath\":\"/22150725263/300x100-BusDir-mobile-5\",\"adWidth\":\"300\",\"adHeight\":\"100\",\"adDivId\":\"div-gpt-ad-1656357277138-0\"}"
  ],
  "spacingTop": "40",
  "lazyLoadAd": "true"
}

export const companyProfileDesktopSix = {
  "spacingBottom": "40",
  "ad": [
      "{\"adUnitPath\":\"/22150725263/728x90-BusDir-desktop-6\",\"adWidth\":\"728\",\"adHeight\":\"90\",\"adDivId\":\"div-gpt-ad-1656357159721-0\"}",
      "{\"adUnitPath\":\"/22150725263/300x100-BusDir-mobile-6\",\"adWidth\":\"300\",\"adHeight\":\"100\",\"adDivId\":\"div-gpt-ad-1656357300376-0\"}"
  ],
  "spacingTop": "40",
  "lazyLoadAd": "true"
}
